/*
 * Public API Surface of strangularlib
 */

export * from './lib/strangularlib.service';
export * from './lib/strangularlib.component';
export * from './lib/strangularlib.module';
export * from './lib/test-adder/test-adder.component'
export * from './lib/test-subtract/test-subtract.component'
